export * from './cart.register';
export * from './cart.actions';
export * from './cart.reducer';

export type CartTax = {
    label: string;
    amount: number;
};

export type MediaEntry = {
    label: string;
    url: string;
};

export type CartDiscount = {
    label: string;
    amount: number;
};

export type CartTotals = {
    grand_total: number;
    subtotal_including_tax: number;
    subtotal_excluding_tax: number;
    discounts: CartDiscount[];
    applied_taxes: CartTax[];
};

export type CartItem =
    | {
          __typename: 'ConfigurableCartItem';
          id: string;
          prices: CartItemPrice;
          quantity: number;
          product: CartProduct;
          configurable_options: CartConfigOption[];
          configured_variant: CartConfigVariant;
      }
    | {
          __typename: 'BundleCartItem';
          id: string;
          prices: CartItemPrice;
          quantity: number;
          product: CartProduct;
          bundle_options: CartBundleOption[];
      }
    | {
          __typename: 'SimpleCartItem';
          id: string;
          prices: CartItemPrice;
          quantity: number;
          product: CartProduct;
      };

export type CartConfigOption = {
    id: number;
    option_label: string;
    value_id: number;
    value_label: string;
};

export type CartConfigVariant = {
    click_and_collected: number;
    home_delivery: number;
    is_available_hd_delivery_centre: number;
    delivery_type: number;
    sku: string;
    small_image: {
        url: string;
        label: string;
    };
};

export type CartBundleOption = {
    label: string;
    type: string;
    values: CartBundleOptionValue[];
};

export type CartBundleOptionValue = {
    quantity: number;
    label: string;
    id: number;
    price: number;
};

export type CartProduct = {
    __typename: 'BundleProduct' | 'ConfigurableProduct' | 'SimpleProduct' | 'GroupedProduct' | 'VirtualProduct';
    small_image: MediaEntry;
    name: string;
    sku: string;
    pathname: string;
    id: number;
};

export type CartItemPrice = {
    price: number;
    row_total: number;
    row_total_including_tax: number;
};
